// import { map } from "lodash";
// import Learner from "@/models/Learner";
import LearningUnit from '@/models/LearningUnit';
import Section from '@/models/Section';

export const feedMixin = {
  data() {
    return {
      // feedMixin_feedListQuery: null
    };
  },

  computed: {
    $_feedMixin_learningUnitId() {
      return Number.parseInt(this.$route.params.learningUnitId);
    },

    $_feedMixin_learningUnit() {
      return LearningUnit.query()
        .with('ultimate_learning_outcome')
        .whereId(this.$_feedMixin_learningUnitId)
        .first();
    },

    $_feedMixin_sectionId() {
      return Number.parseInt(this.$route.params.sectionId);
    },

    $_feedMixin_section() {
      return Section.query()
        .with('section_repeat')
        .with('user_enrollments')
        .whereId(this.$_feedMixin_sectionId)
        .first();
    }
  },

  methods: {}
};
